import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Empty, Progress, Row, Skeleton, Typography } from 'antd';
import { FileTextOutlined, PlayCircleOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../services/api';
import { TrainingFolder } from '../types';
import './VideoPortal.css';

const { Title, Paragraph, Text } = Typography;

const VideoPortal: React.FC = () => {
  const navigate = useNavigate();
  const [folders, setFolders] = useState<TrainingFolder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get<TrainingFolder[]>('/video/folders')
      .then(({ data }) => setFolders(data))
      .catch((err) => setError(err?.response?.data?.detail || 'Не удалось загрузить видеопортал'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div data-guide="materials-catalog" className="video-page-head">
        <div>
          <Text className="video-eyebrow">БАЗА ЗНАНИЙ</Text>
          <Title level={1}>Материалы обучения</Title>
          <Paragraph type="secondary">Видео, презентации и транскрибации корпоративных обучений</Paragraph>
        </div>
        <VideoCameraOutlined className="video-head-icon" />
      </div>

      {error && <Alert type="error" showIcon message={error} className="video-alert" />}
      {loading ? (
        <Row gutter={[20, 20]}>{[1, 2, 3].map((item) => <Col xs={24} md={12} lg={8} key={item}><Card><Skeleton active /></Card></Col>)}</Row>
      ) : folders.length === 0 ? (
        <Card><Empty description="Материалы обучений пока не добавлены" /></Card>
      ) : (
        <Row gutter={[20, 20]}>
          {folders.map((folder) => (
            <Col xs={24} md={12} lg={8} key={folder.id}>
              <Card
                hoverable
                data-guide="learning-folder"
                className="video-folder-card"
                onClick={() => navigate(`/videos/folders/${folder.id}`)}
              >
                <Title level={4}>{folder.title}</Title>
                <Paragraph ellipsis={{ rows: 2 }}>{folder.description || 'Без описания'}</Paragraph>
                <div className="video-folder-meta">
                  <span><PlayCircleOutlined /> {folder.video_count} видео</span>
                  <span><FileTextOutlined /> {folder.document_count || 0} документов</span>
                  <span>{folder.completed_videos + (folder.completed_documents || 0)} изучено</span>
                </div>
                <Progress percent={Math.round(folder.progress_percent)} size="small" />
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Layout>
  );
};

export default VideoPortal;
